import Vue from 'vue';
import { appTheme, applyTheme, getStoredTheme } from '@/features/theme/theme';
import { THEMES } from '@/features/theme/themes';
import Vuetify from 'vuetify';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import styles
import 'tiptap-vuetify/dist/main.css'

// first it
// Classic (default) or Sophia palette, depending on what the active account chose
const initialTheme = getStoredTheme();
Vue.use(Vuetify, { theme: { ...THEMES[initialTheme].palette } })
Vue.prototype.$appTheme = appTheme
applyTheme(initialTheme)
// AFTER Vue.use(Vuetify) !!!
Vue.use(TiptapVuetifyPlugin, {
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md'
})